var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42865_476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 12.5001L7.49992 10.0001M9.99992 12.5001C11.164 12.0574 12.2807 11.499 13.3333 10.8334M9.99992 12.5001V16.6668C9.99992 16.6668 12.5249 16.2084 13.3333 15.0001C14.2333 13.6501 13.3333 10.8334 13.3333 10.8334M7.49992 10.0001C7.94337 8.84963 8.50175 7.74683 9.16659 6.70844C10.1376 5.15593 11.4896 3.87765 13.0941 2.99518C14.6986 2.11272 16.5021 1.65542 18.3333 1.66677C18.3333 3.93344 17.6833 7.91677 13.3333 10.8334M7.49992 10.0001H3.33325C3.33325 10.0001 3.79159 7.47511 4.99992 6.66677C6.34992 5.76677 9.16659 6.66677 9.16659 6.66677M3.74992 13.7501C2.49992 14.8001 2.08325 17.9168 2.08325 17.9168C2.08325 17.9168 5.19992 17.5001 6.24992 16.2501C6.84159 15.5501 6.83325 14.4751 6.17492 13.8251C5.85101 13.5159 5.42433 13.3373 4.97677 13.3235C4.52922 13.3096 4.09232 13.4616 3.74992 13.7501Z",
    stroke: "#0265DC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42865_476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/Boost.4d57f90e635ff2e8cf5914ea87bf1a6b.svg";
export { ForwardRef as ReactComponent };